<template>
  <div>
    <router-view></router-view>
  </div>
  
</template>
<script>
 import ResizeHandler from "@/utils/ResizeHandler"
export default {
  mixins:[ResizeHandler],
  data() {
    return {
      
    };
  },
  mounted(){
    
  },
  computed: {
    
  },
};
</script>


<style lang="scss" scoped>
 
</style>
